module.exports = __webpack_public_path__ + "static/media/get-paid-ipswich.13b43778.png";